const zh = {
  // Navbar
  "nav.home": "首页",
  "nav.services": "服务",
  "nav.cases": "案例",
  "nav.contact": "联系",
  "nav.cta": "免费咨询",

  // Hero Carousel
  "hero.slide1.tag": "专业数字解决方案提供商",
  "hero.slide1.title": "打造卓越数字产品",
  "hero.slide1.subtitle": "助力企业腾飞",
  "hero.slide1.desc": "从网站开发到移动应用，提供全方位技术咨询与维护服务，让您的业务在数字时代脱颖而出。",
  "hero.slide1.cta1": "开始项目",
  "hero.slide1.cta2": "查看案例",
  "hero.slide2.tag": "网站开发专家",
  "hero.slide2.title": "精美网站",
  "hero.slide2.subtitle": "驱动业务增长",
  "hero.slide2.desc": "我们为各类企业量身打造响应式网站，融合现代设计美学与卓越技术性能，让您的品牌在线上熠熠生辉。",
  "hero.slide2.cta1": "了解服务",
  "hero.slide2.cta2": "免费咨询",
  "hero.slide3.tag": "移动应用开发",
  "hero.slide3.title": "智能移动应用",
  "hero.slide3.subtitle": "连接用户与未来",
  "hero.slide3.desc": "专业的 iOS 与 Android 应用开发团队，从产品规划到上线运营，全程陪伴您的数字化转型之旅。",
  "hero.slide3.cta1": "查看案例",
  "hero.slide3.cta2": "立即咨询",

  // Services
  "services.badge": "我们的服务",
  "services.title": "专业技术服务",
  "services.desc": "我们提供全方位的数字化解决方案，从概念设计到产品落地，每一步都精益求精，助力您的业务腾飞。",
  "services.web.title": "网站开发",
  "services.web.desc": "为企业量身打造响应式官网、电商平台及 Web 应用，融合现代设计美学与卓越技术性能，提升品牌在线影响力。",
  "services.web.f1": "响应式设计",
  "services.web.f2": "SEO 优化",
  "services.web.f3": "高性能架构",
  "services.web.f4": "CMS 集成",
  "services.app.title": "移动应用开发",
  "services.app.desc": "专业开发 iOS 与 Android 原生及跨平台应用，从产品规划到上线运营，全程陪伴您的移动端数字化转型。",
  "services.app.f1": "iOS & Android",
  "services.app.f2": "跨平台开发",
  "services.app.f3": "UI/UX 设计",
  "services.app.f4": "App Store 上架",
  "services.consult.title": "技术咨询",
  "services.consult.desc": "提供个性化技术战略咨询，帮助企业选择最适合的技术栈与架构方案，降低技术风险，加速业务落地。",
  "services.consult.f1": "技术选型",
  "services.consult.f2": "架构设计",
  "services.consult.f3": "数字化战略",
  "services.consult.f4": "团队培训",
  "services.maintain.title": "维护与支持",
  "services.maintain.desc": "提供 7×24 小时系统监控与维护服务，定期安全更新、性能优化，确保您的数字产品稳定高效运行。",
  "services.maintain.f1": "7×24 监控",
  "services.maintain.f2": "安全更新",
  "services.maintain.f3": "性能优化",
  "services.maintain.f4": "技术支持",
  "services.stat1.num": "150+",
  "services.stat1.label": "成功项目",
  "services.stat2.num": "98%",
  "services.stat2.label": "客户满意度",
  "services.stat3.num": "8+",
  "services.stat3.label": "年行业经验",
  "services.stat4.num": "24/7",
  "services.stat4.label": "技术支持",

  // Cases
  "cases.modal.view": "查看详情",
  "cases.badge": "精选案例",
  "cases.title": "精选案例",
  "cases.desc": "每一个项目都是我们对卓越品质的承诺，见证数字产品如何驱动真实业务增长。",
  "cases.cta": "查看更多案例",
  "cases.page.title": "全部案例",
  "cases.page.desc": "探索我们完整的数字产品作品集——从电商平台到企业软件，每个项目都体现了我们对卓越品质的承诺。",
  "cases.page.filter.all": "全部",
  "cases.page.filter.web": "网站开发",
  "cases.page.filter.app": "移动应用",
  "cases.page.filter.enterprise": "企业软件",
  "cases.page.back": "返回首页",
  "cases.page.cta.title": "准备好打造卓越产品了吗？",
  "cases.page.cta.desc": "让我们一起探讨您的项目，共同创造下一个成功案例。",
  "cases.page.cta.btn": "开启项目",
  "cases.c1.title": "LuxeCart 电商平台",
  "cases.c1.type": "网站开发",
  "cases.c1.desc": "为高端时尚品牌打造的全功能电商平台，支持多语言、多货币，月均 GMV 突破 500 万。",
  "cases.c2.title": "MediConnect 医疗预约 App",
  "cases.c2.type": "移动应用开发",
  "cases.c2.desc": "连接患者与医生的智能预约平台，上线 6 个月用户突破 10 万，获评年度最佳医疗应用。",
  "cases.c3.title": "FinTrack 财务管理系统",
  "cases.c3.type": "企业软件开发",
  "cases.c3.desc": "为中小企业定制的 SaaS 财务管理平台，集成 AI 智能分析，帮助企业实现精细化财务管控。",

  // Case modal details
  "cases.c1.client": "LuxeCart 时尚集团",
  "cases.c1.challenge": "客户需要一个高性能电商平台，能够承载大促期间的流量峰值，支持东南亚多语言、多货币交易，同时保持高端品牌的视觉体验与一致性。",
  "cases.c1.solution": "我们采用 React + Shopify 无头商务架构，结合自定义 CDN 策略与边缘缓存，确保全球访问速度低于 1 秒。同时为品牌量身打造设计系统，在所有触点上呈现奢华品牌调性。",
  "cases.c1.result1": "上线 3 个月内月均 GMV 突破 500 万新元",
  "cases.c1.result2": "页面加载速度提升 65%，跳出率下降 40%",
  "cases.c1.result3": "无缝支持 8 种语言、12 种货币",
  "cases.c1.result4": "大促期间成功承载 5 万并发用户",

  "cases.c2.client": "MediConnect 医疗科技",
  "cases.c2.challenge": "患者面临预约等待时间长、专科医生难以触达的问题。客户需要一个统一平台，连接患者、全科医生与专科医生，实现实时排班与 AI 辅助分诊。",
  "cases.c2.solution": "我们使用 React Native 与 Supabase 开发跨平台移动应用，集成 AI 症状自查、实时号源管理与安全视频问诊功能，并通过 HL7 FHIR API 与医院现有 EMR 系统对接。",
  "cases.c2.result1": "上线 6 个月注册用户突破 10 万",
  "cases.c2.result2": "平均预约等待时间从 3 天缩短至 4 小时",
  "cases.c2.result3": "荣获新加坡 HealthTech Awards 年度最佳医疗应用",
  "cases.c2.result4": "App Store 与 Google Play 双平台评分 4.8 星",

  "cases.c3.client": "FinTrack 财务科技",
  "cases.c3.challenge": "中小企业财务数据分散在多个工具中，难以获取实时洞察，税务合规耗时费力。财务团队每月手工报表工作超过 20 小时。",
  "cases.c3.solution": "我们构建了 Vue.js 前端 + Python 微服务后端的 SaaS 平台，实现银行流水自动对账、AI 现金流预测，以及与 IRAS 对接的一键 GST 报税功能。",
  "cases.c3.result1": "财务报表工作量平均减少 85%",
  "cases.c3.result2": "首年内超过 2000 家中小企业完成入驻",
  "cases.c3.result3": "AI 预测 90 天现金流准确率达 94%",
  "cases.c3.result4": "完全符合新加坡 GST 及 MAS 报告要求",

  "cases.c4.client": "HomeNest 房产中介",
  "cases.c4.challenge": "中介依赖老旧房产门户，用户体验差且缺乏品牌差异化。他们需要一个自有平台，配备高级搜索、虚拟看房和房贷工具，以吸引高净值买家。",
  "cases.c4.solution": "我们交付了基于 Next.js 的服务端渲染平台，集成 3D 虚拟看房、AI 房源推荐引擎，以及接入实时银行利率的房贷计算器，全面提升 SEO 与用户体验。",
  "cases.c4.result1": "6 个月内自然搜索流量增长 220%",
  "cases.c4.result2": "线索转化率从 1.2% 提升至 4.7%",
  "cases.c4.result3": "平均访问时长增加 3.5 分钟",
  "cases.c4.result4": "入选 PropertyGuru 2024 年度十大 PropTech 创新",

  "cases.c5.client": "FitPulse 健身科技",
  "cases.c5.challenge": "健身应用市场同质化严重。客户希望打造一款 AI 私教应用，能根据个人体能自适应调整，接入可穿戴设备，并通过手机摄像头实时纠正动作姿势。",
  "cases.c5.solution": "我们使用 Flutter 开发应用，集成端侧 ML 模型实现实时姿态估计，Firebase 实现多设备实时同步，个性化训练引擎根据表现数据与恢复指标动态调整计划。",
  "cases.c5.result1": "上线首月下载量突破 5 万",
  "cases.c5.result2": "78% 的用户反馈 8 周内体能明显改善",
  "cases.c5.result3": "用户日均活跃使用时长 24 分钟",
  "cases.c5.result4": "在 3 个国家 App Store 获评每日精选应用",

  "cases.c6.client": "GlobalManu 跨国制造集团",
  "cases.c6.challenge": "该制造商在 12 个国家运营，供应链系统各自为政，导致库存错配、发货延误，每年物流成本超支 15%，全链路可视化几乎为零。",
  "cases.c6.solution": "我们在 AWS 上构建统一供应链平台，React 前端 + Java 微服务后端，实现 IoT 实时追踪、预测性需求预测、自动采购单生成，以及供应商协作门户。",
  "cases.c6.result1": "首年物流成本降低 30%",
  "cases.c6.result2": "准时交货率从 82% 提升至 99.5%",
  "cases.c6.result3": "需求预测使库存持有成本降低 25%",
  "cases.c6.result4": "实现 12 个国家、200+ 供应商的实时全链路可视化",

  // Contact
  "contact.badge": "联系我们",
  "contact.title": "开启您的数字化之旅",
  "contact.desc": "无论您有任何想法或需求，我们的专业团队随时为您提供咨询，共同打造卓越数字产品。",
  "contact.left.title": "让我们一起\n创造非凡",
  "contact.left.desc": "专业团队随时为您提供咨询，从需求分析到产品交付，全程陪伴您的数字化转型之旅。",
  "contact.phone": "+65 9662 8319",
  "contact.whatsapp": "WhatsApp: +65 9662 8319",
  "contact.email": "cs@risephoenixtech.com",
  "contact.address": "Singapore",
  "contact.form.name": "姓名",
  "contact.form.name.placeholder": "您的姓名",
  "contact.form.company": "公司名称",
  "contact.form.company.placeholder": "您的公司",
  "contact.form.email": "邮箱",
  "contact.form.phone": "电话",
  "contact.form.phone.placeholder": "+86 138 0000 0000",
  "contact.form.type": "项目类型",
  "contact.form.type.placeholder": "请选择项目类型",
  "contact.form.type.web": "网站开发",
  "contact.form.type.app": "移动应用开发",
  "contact.form.type.consult": "技术咨询",
  "contact.form.type.maintain": "维护与支持",
  "contact.form.type.other": "其他",
  "contact.form.message": "项目描述",
  "contact.form.message.placeholder": "请简要描述您的项目需求、预算范围及期望交付时间...",
  "contact.form.submit": "提交咨询",
  "contact.form.submitting": "提交中...",
  "contact.form.success.title": "提交成功！",
  "contact.form.success.desc": "感谢您的咨询，我们的团队将在 24 小时内与您联系。",
  "contact.form.success.again": "再次提交",
  "contact.form.error": "提交失败，请稍后重试或直接联系我们。",
  "contact.required": "*",

  // Footer
  "footer.desc": "专注于软件开发与数字化解决方案，为企业提供网站开发、移动应用、技术咨询及维护服务，打造高质量数字产品，助力企业腾飞。",
  "footer.services": "服务",
  "footer.service1": "网站开发",
  "footer.service2": "移动应用开发",
  "footer.service3": "技术咨询",
  "footer.service4": "维护与支持",
  "footer.service5": "数字化转型",
  "footer.contact": "联系我们",
  "footer.address": "Singapore",
  "footer.copyright": "© 2025 Rise Phoenix. All rights reserved.",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.sitemap": "网站地图",
};

export default zh;
